import React, { Component } from "react";

import Modal from "./Modal";

import HSL from "../toolbar/adjust/hsl/HSL";

export default class HSLModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
    };
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps;
  }

  render() {
    return (
      <>
        <style
          dangerouslySetInnerHTML={{
            __html: `
              .modal-backdrop.show {
                  opacity:0;
              }
            `,
          }}
        />
        <Modal
          className="modal-hsl p-btm"
          show={this.state.show}
          onHide={() => {
            this.props.onHide();
          }}
        >
          <HSL
            compact={true}
            hsl={this.props.hsl}
            filter={this.props.filter}
            onFilterUpdated={this.props.onFilterUpdated}
            onUpdated={this.props.onUpdated}
          />
        </Modal>
      </>
    );
  }
}
